import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetEnfoqueDiferencial } from '../shared/interfaces/configuracion';
import { RevocarFirmaElectronicaDTO } from '../shared/interfaces/firma_electronica';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class SolicitudRevocacionService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/firma-electronica/solicitud-revocacion`;
  }

  crearSolicitudRevocarFirmaElectronica(request: RevocarFirmaElectronicaDTO): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}`, request);
  }
}
